import {
    Component,
    ElementRef,
    HostBinding,
    ViewEncapsulation,
    inject,
    input,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --star-active: gold; --star-inactive: gray; display: inline-block; height: var(--size); vertical-align: middle; } :host .bazis-star { fill: var(--star-inactive); width: var(--size); height: var(--size); } :host .bazis-star--active { fill: var(--star-active); }`,
);

@Component({
    selector: 'bazis-star',
    templateUrl: './star.component.html',
    // styleUrls: ['star.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StarElement implements OnInit {
    public el = inject(ElementRef);

    readonly size = input<number>(16);

    readonly svgStarPath = input<string>(
        'M12.978 15.5437L8.00001 11.8851L3.02201 15.5437L4.93334 9.63506L-0.0419922 5.99972H6.10067L8.00001 0.0810547L9.89934 5.99972H16.0413L11.0667 9.63506L12.978 15.5437Z',
    );

    readonly isActive = input<boolean>(false);

    readonly isHalf = input<boolean>(false);

    @HostBinding('style') get starStyle() {
        return {
            [`--size`]: this.size(),
        };
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
